import {
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "../components/home";
import Dashboard from "../components/dashboard";
import Users from "../components/users";
import AuthUser from "../components/AuthUser";
import { canEdit } from "../utils/permissions";
import Tasks from "../components/tasks";
import Tasksview from "../components/tasksview";
import Yourtask from "../components/yourtasks";
import Departmenttask from "../components/departmenttask";
import Weekmonthview from "../components/weekmonthview";
import Weekmonthadd from "../components/weekmonthadd";
import Report from "../components/report";
import Departmentview from "../components/departmentview";
import Department_add from "../components/department_add";
import toast, { Toaster } from "react-hot-toast";
import Resetpassword from "../components/resetpassword";
import Designation from "../components/designation";
import Designation_add from "../components/designation_add";
import Compny_add from "../components/compny_add";
import Company_view from "../components/company_view";
import BulkTask from "../components/bulktask";
import BulkTaskWeek from "../components/bulktaskweek";
import Taskjob from "../components/taskjob";
import Customer from "../components/customer";
import Customeradd from "../components/customeradd";
import Customerenqadd from "../components/customerenqadd";
import Customerenq from "../components/customerenq";
import Dashboard_job from "../components/dashboard_job";
import Amc_list from "../components/amc_list";
import Assign_amc from "../components/assign_amc";
import Jc_time from "../components/jc_time";
import Jc_time_report from "../components/jc_time_report";
import Branch from "../components/branch";
import Branch_add from "../components/branch_add";
import Jcanti from "../components/jacanti";
import Jacanti from "../components/jacanti";
import Jaantilist from "../components/jaantilist";
import Category_add from "../components/category_add";
import Category from "../components/category";
import Master_add from "../components/master_add";
import Master from "../components/master";
import Stocks from "../components/stocks";
import Stocks_add from "../components/stocks_add";
import Jc_timelive from "../components/jc_timelive";
import Hq from "../components/hq";
import Print from "../components/print";
import PrintSimple from "../components/PrintSimple";
import Jcreport from "../components/jcreport";
import Jcardreport from "../components/jcardreport";
import Jc_amc from "../components/jc_amc";
import Amc_dashboard from "../components/amc_dashboard";
import Jc_dash from "../components/jc_dash";
import List_group from "../components/list_group";
import Group_task from "../components/group_task";
import Bulk_task_group from "../components/bulk_task_group";
import Amc_report from "../components/amc_report";
import Amc_detail_report from "../components/amc_detail_report";
import Ojc_time_report from "../components/ojc_time_report";
import Reached_time_report from "../components/reached_time_report";
import Purchase from "../components/purchase";
import Dlmodule from "../components/dlmodule";
import Invoice from "../components/invoice";
import StreamCategoryList from "../components/StreamCategoryList";
import StreamVideoList from "../components/StreamVideoList";
import StreamUserList from "../components/StreamUserList";
import StreamVidCategoryList from "../components/StreamVidCategoryList";
import AntivirusMasterList from "../components/AntivirusMasterList";
import AntivirusRequestList from "../components/AntivirusRequestList";
import AntivirusReport from "../components/AntivirusReport";
import TypeNameAntivirusMasterList from "../components/TypeNameAntivirusMasterList";
import ReminderTypeList from "../components/ReminderTypeList";
import ReminderSummary from "../components/ReminderSummary";
import ReminderCustomerSummary from "../components/ReminderCustomerSummary";
import JcBranchReport from "../components/JcBranchReport";
import JcPendingReport from "../components/JcPendingReport";
import MsKeyList from "../components/MsKeyList";
import MsSubKeyList from "../components/MsSubKeyList";
import MsChildKeyList from "../components/MsChildKeyList";
import MsKeyViewAll from "../components/MsKeyViewAll";
import MsKeyTableView from "../components/MsKeyTableView";
import AssetHeadList from "../components/AssetHeadList";
import AssetItemMasterList from "../components/AssetItemMasterList";
import AssetDepartmentList from "../components/AssetDepartmentList";
import AssetList from "../components/AssetList";

function Auth() {
  const { http } = AuthUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [showNavbar, setShowNavbar] = useState(false);
  const [statusUser, setStatus] = useState();
  const [companylogo, setCompanylogo] = useState();
  const [companyname, setCompanyname] = useState();
  const { token, logout, user } = AuthUser();
  const allowEdit = canEdit(user);
  const logoutUser = () => {
    if (token != undefined) {
      logout();
    }
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/jobcart/print") {
      setShowNavbar(true);
    } else {
      setShowNavbar(false);
    }
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    // await http.get(`/user_status=${user.id}`).then((res) => {
    //     setStatus(res[0].status);
    // })

    await http.get(`/companyinfo?login_user=${user.id}`).then((resp) => {
      setCompanyname(resp.data.data[0].company_name);
      //console.log('resp',resp.data.data[0].company_name);
      setCompanylogo(resp.data.data[0].company_logo);
    });
  };

  if (user.status === 0) {
    sessionStorage.clear();
    navigate("/login");
    toast.error("Your Account Not Yet Approved !");
    setTimeout(() => {
      navigate("/login");
    }, 2000);
  }

  // Check if the current URL is http://localhost:3000/jobcart
  const isJobCartPage = location.pathname.startsWith("/jobcart");

  if (isJobCartPage) {
    if (user.branch_admin != 1) {
      sessionStorage.clear();
      navigate("/jobcart/login");
      toast.error("Your Account Not Yet Approved !");
      setTimeout(() => {
        navigate("/jobcart/login");
      }, 1000);
    }
    return (
      <>
        <Toaster />

        <nav className="navbar navbar-expand-sm navbar-dark bg-gray">
          <div className="container-fluid">
            <a className="navbar-brand" href="/jobcart/dashboard-job">
              {companylogo ? (
                <img
                  src={`http://3.6.125.26/api/storage/tasks/${companylogo}`}
                  alt="Company Logo"
                  width="82"
                  height="39"
                />
              ) : (
                <img
                  src="/logo.png"
                  alt="Default Logo"
                  width="82"
                  height="39"
                />
              )}
            </a>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Collapsing navbar content */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ">
                {" "}
                {/* ms-auto will push items to the right */}
                <li
                  className={`nav-item ${location.pathname === "/jobcart/dashboard-job"
                    ? "active"
                    : ""
                    }`}
                >
                  <Link
                    className="nav-link text-white"
                    to="/jobcart/dashboard-job"
                  >
                    JC
                  </Link>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/hq" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/hq">
                    HQ
                  </Link>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/taskjob" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/taskjob">
                    Add JC
                  </Link>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/customer" ||
                    location.pathname === "/jobcart/customeradd"
                    ? "active"
                    : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/customer">
                    Customers
                  </Link>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/customerenq" ||
                    location.pathname === "/jobcart/customerenqadd"
                    ? "active"
                    : ""
                    }`}
                >
                  <Link
                    className="nav-link text-white"
                    to="/jobcart/customerenq"
                  >
                    Enquiry
                  </Link>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/amc_list" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/amc_list">
                    AMC
                  </Link>
                </li>
                <li
                  className={`nav-item dropdown ${location.pathname === "/jobcart/jc_time" ||
                    location.pathname === "/jobcart/jc_time_report"
                    ? "active"
                    : ""
                    }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="worksDataDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Works Data
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="worksDataDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/jobcart/jc_time">
                        JC Time Availability
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/jc_time_report">
                        Workload Report
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/branch" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/branch">
                    Branches
                  </Link>
                </li>
                <li
                  className={`nav-item dropdown ${location.pathname === "/jobcart/reminder" ||
                    location.pathname === "/jobcart/reminder_types" ||
                    location.pathname === "/jobcart/reminder_summary" ||
                    location.pathname === "/jobcart/reminder_customer_summary"
                    ? "active"
                    : ""
                    }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="reminderDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Reminder
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="reminderDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/jobcart/reminder">
                        Reminder List
                      </Link>
                    </li>
                    {user && (user.id == 1 || user.id == 3) && (
                    <li>
                      <Link className="dropdown-item" to="/jobcart/reminder_summary">
                        Reminder Summary
                      </Link>
                    </li>
                    )}
                    {user && (user.id == 1 || user.id == 3) && (
                    <li>
                      <Link className="dropdown-item" to="/jobcart/reminder_customer_summary">
                        Remind Customer Summary
                      </Link>
                    </li>
                    )}
                    {user && user.department_id === 1 && (
                      <li>
                        <Link className="dropdown-item" to="/jobcart/reminder_types">
                          Reminder Type
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/jobcart/invoice" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/jobcart/invoice">
                    Invoice
                  </Link>
                </li>
                <li
                  className={`nav-item dropdown ${location.pathname === "/add_category" ||
                    location.pathname === "/stocks" ||
                    location.pathname === "/category" ||
                    location.pathname === "/add_master" ||
                    location.pathname === "/master"
                    ? "active"
                    : ""
                    }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Stocks
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/jobcart/stocks">
                        Stocks
                      </Link>
                    </li>
                    {user && user.department_id === 1 && (
                      <li>
                        <Link className="dropdown-item" to="/jobcart/master">
                          Master
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link className="dropdown-item" to="/jobcart/category">
                        Category
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/purchase">
                        Purchase
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className={`nav-item dropdown ${[
                    "/jobcart/jcreport",
                    "/jobcart/jcardreport",
                    "/jobcart/amcreport",
                    "/jobcart/amc_detail_report",
                    "/jobcart/ojc_time_report",
                    "/jobcart/reached_time_report",
                    "/jobcart/jc_branch_report",
                    "/jobcart/jc_pending_report"
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                  }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="reportDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Report
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="reportDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/jobcart/jcreport">
                        Stock Report
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/jc_branch_report">
                        JC Branch Report
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/jc_pending_report">
                        JC Pending Report
                      </Link>
                    </li>
                    {user && user.department_id === 1 && (
                      <>
                        <li>
                          <Link className="dropdown-item" to="/jobcart/jcardreport">
                            Jc Report
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/jobcart/amcreport">
                            AMC Report
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/jobcart/amc_detail_report">
                            Total Overall Report
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/jobcart/ojc_time_report">
                            OJC-Time Report
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/jobcart/reached_time_report">
                            Reached Time Report
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </li>

                {/* {user && user.department_id === 1 && ( */}
                  <li
                    className={`nav-item dropdown ${location.pathname === "/jobcart/type_name_antivirus_master" ||
                      location.pathname === "/jobcart/antivirus_master" ||
                      location.pathname === "/jobcart/antivirus_request" ||
                      location.pathname === "/jobcart/antivirus_report"
                      ? "active"
                      : ""
                      }`}
                  >
                    <a
                      className="nav-link dropdown-toggle text-white"
                      href="#"
                      id="antivirusDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Antivirus
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="antivirusDropdown"
                    >
                      {user && user.department_id === 1 && (
                        <div>
                      <li>
                        <Link className="dropdown-item" to="/jobcart/type_name_antivirus_master">
                          Type Name Master
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/jobcart/antivirus_master">
                          Anti-Master
                        </Link>
                      </li>
                      </div>
                      )}
                      <li>
                        <Link className="dropdown-item" to="/jobcart/antivirus_request">
                          Request List
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/jobcart/antivirus_report">
                          Report
                        </Link>
                      </li>
                    </ul>
                  </li>
                {/* )} */}

                <li
                  className={`nav-item dropdown ${
                    location.pathname === "/jobcart/ms_key" ||
                    location.pathname === "/jobcart/ms_sub_key" ||
                    location.pathname === "/jobcart/ms_child_key" ||
                    location.pathname === "/jobcart/ms_key_view" ||
                    location.pathname === "/jobcart/ms_key_table"
                      ? "active"
                      : ""
                  }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="msKeyDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    MS Key
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="msKeyDropdown">
                    <li>
                      <Link className="dropdown-item" to="/jobcart/ms_key">
                        Master Key
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/ms_sub_key">
                        Sub Keys
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/ms_child_key">
                        Child Keys
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/ms_key_view">
                        View All (Tree)
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/ms_key_table">
                        Table View
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className={`nav-item dropdown ${
                    location.pathname.startsWith("/jobcart/asset_")
                      ? "active"
                      : ""
                  }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="assetMgmtDropdownJob"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Asset MNGT
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="assetMgmtDropdownJob">
                    <li>
                      <Link className="dropdown-item" to="/jobcart/asset_heads">
                        Asset Head
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/asset_item_masters">
                        Item Master
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/asset_departments">
                        Asset Department
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobcart/asset_list">
                        Asset List
                      </Link>
                    </li>
                  </ul>
                </li>
                
                <li className="nav-item">
                  <span
                    role="button"
                    className="nav-link text-danger"
                    onClick={logoutUser}
                  >
                    Logout
                  </span>
                </li>
              </ul>
            </div>

            <span className="text-warning text-end pull-right text-uppercase mx-3">
              {companyname}
            </span>
            <span className="text-white text-end pull-right px-2">Hi👋🏻</span>
            <span className="text-white text-end pull-right text-uppercase">
              {" "}
              {user.name + " " + user.last_name}
            </span>
          </div>
        </nav>

        <div className="containers">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/jobcart/dashboard-job" element={<Dashboard_job />} />
            <Route path="/jobcart/hq" element={<Hq />} />
            <Route path="/jobcart/taskjob" element={<Taskjob />} />
            <Route path="/jobcart/customer" element={<Customer />} />
            <Route path="/jobcart/customeradd" element={<Customeradd />} />
            <Route path="/jobcart/jcreport" element={<Jcreport />} />
            <Route path="/jobcart/jcardreport" element={<Jcardreport />} />
            <Route path="/jobcart/amcreport" element={<Amc_report />} />
            <Route path="/jobcart/amc_detail_report" element={<Amc_detail_report />} />
            <Route path="/jobcart/ojc_time_report" element={<Ojc_time_report />} />
            <Route path="/jobcart/reached_time_report" element={<Reached_time_report />} />
            <Route path="/jobcart/customerenq" element={<Customerenq />} />
            <Route path="/jobcart/branch" element={<Branch />} />
            <Route path="/jobcart/branch_add" element={<Branch_add />} />
            <Route
              path="/jobcart/customerenqadd"
              element={<Customerenqadd />}
            />
            <Route path="/jobcart/amc_list" element={<Amc_list />} />
            <Route path="/jobcart/assign_amc/:id" element={<Assign_amc />} />
            <Route path="/jobcart/jc_time" element={<Jc_time />} />
            <Route path="/jobcart/jc_time_report" element={<Jc_time_report />} />
            <Route path="/jobcart/jcvirus" element={<Jacanti />} />
            <Route path="/jobcart/jc_branch_report" element={<JcBranchReport />} />
            <Route path="/jobcart/jc_pending_report" element={<JcPendingReport />} />
            <Route path="/jobcart/reminder" element={<Jaantilist />} />
            <Route path="/jobcart/reminder_types" element={<ReminderTypeList />} />
            <Route path="/jobcart/reminder_summary" element={<ReminderSummary />} />
            <Route path="/jobcart/reminder_customer_summary" element={<ReminderCustomerSummary />} />
            <Route path="/jobcart/category_add" element={<Category_add />} />
            <Route path="/jobcart/master_add" element={<Master_add />} />
            <Route path="/jobcart/stocks_add" element={<Stocks_add />} />
            <Route path="/jobcart/master" element={<Master />} />
            <Route path="/jobcart/stocks" element={<Stocks />} />
            <Route path="/jobcart/category" element={<Category />} />
            <Route path="/jobcart/purchase" element={<Purchase />} />
            <Route path="/jobcart/invoice" element={<Invoice />} />
            <Route path="/jobcart/print/:id" element={<Print />} />
            <Route path="/jobcart/print_simple/:id" element={<PrintSimple />} />
            <Route path="/jobcart/type_name_antivirus_master" element={<TypeNameAntivirusMasterList />} />
            <Route path="/jobcart/antivirus_master" element={<AntivirusMasterList />} />
            <Route path="/jobcart/antivirus_request" element={<AntivirusRequestList />} />
            <Route path="/jobcart/antivirus_report" element={<AntivirusReport />} />
            <Route path="/jobcart/ms_key" element={<MsKeyList />} />
            <Route path="/jobcart/ms_sub_key" element={<MsSubKeyList />} />
            <Route path="/jobcart/ms_child_key" element={<MsChildKeyList />} />
            <Route path="/jobcart/ms_key_view" element={<MsKeyViewAll />} />
            <Route path="/jobcart/ms_key_table" element={<MsKeyTableView />} />
            <Route path="/jobcart/asset_heads" element={<AssetHeadList />} />
            <Route path="/jobcart/asset_item_masters" element={<AssetItemMasterList />} />
            <Route path="/jobcart/asset_departments" element={<AssetDepartmentList />} />
            <Route path="/jobcart/asset_list" element={<AssetList />} />
          </Routes>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Toaster />
        <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              {companylogo ? (
                <img
                  src={`http://3.6.125.26/api/storage/tasks/${companylogo}`}
                  alt="Company Logo"
                  width="82"
                  height="39"
                />
              ) : (
                <img
                  src="/logo.png"
                  alt="Default Logo"
                  width="82"
                  height="39"
                />
              )}
            </a>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Collapsing navbar content */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ">
                {" "}
                {/* ms-auto will push items to the right */}
                <li
                  className={`nav-item ${location.pathname === "/dashboard" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/dashboard">
                    Dashboard
                  </Link>
                </li>
                <li
                  className={`nav-item dropdown ${location.pathname === "/add_task" ||
                    location.pathname === "/task_view" ||
                    location.pathname === "/task_by_you" ||
                    location.pathname === "/departmenttask"
                    ? "active"
                    : ""
                    }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Task
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/add_task">
                        Add Task
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/bulk_task">
                        Bulk Task
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/bulk_task_group">
                        Group Bulk Tasks
                      </Link>
                    </li>

                    <li>
                      <Link className="dropdown-item" to="/bulk_task_week">
                        Bulk Week/month Task
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/task_view">
                        Your Tasks
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/task_by_you">
                        Task Added By You
                      </Link>
                    </li>

                    <li>
                      <Link className="dropdown-item" to="/departmenttask">
                        Department Tasks
                      </Link>
                    </li>

                    {user && user.company_id == 1 && (
                      <li>
                        <Link className="dropdown-item" to="/amc_dash">
                          JC Tasks
                        </Link>
                      </li>
                    )}

                    {user && user.company_id == 1 && (
                      <li>
                        <Link className="dropdown-item" to="/jc_dash">
                          AMC Tasks
                        </Link>
                      </li>
                    )}
                    {user && user.department_id == 1 && (
                      <li>
                        <Link className="dropdown-item" to="/group_tasks">
                          Create Group
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                {user && user.department_id === 1 && allowEdit && (
                  <li
                    className={`nav-item ${location.pathname === "/users" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/users">
                      Users
                    </Link>
                  </li>
                )}
                {
                  <li
                    className={`nav-item ${location.pathname === "/week_month_task" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/week_month_task">
                      Weekly/Monthly Task
                    </Link>
                  </li>
                }
                {user && user.department_id === 1 && (
                  <li
                    className={`nav-item ${location.pathname === "/department" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/department">
                      Department
                    </Link>
                  </li>
                )}
                <li
                  className={`nav-item ${location.pathname === "/report" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/report">
                    Reports
                  </Link>
                </li>
                {user && user.company_id === 1 && (
                  <li
                    className={`nav-item ${location.pathname === "/invoice" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/invoice">
                      Invoice
                    </Link>
                  </li>
                )}
                {user && user.company_id === 1 && (
                  <li
                    className={`nav-item dropdown ${location.pathname === "/stream_categories" ||
                      location.pathname === "/stream_videos" ||
                      location.pathname === "/stream_users" ||
                      location.pathname === "/stream_vidcategories"
                      ? "active"
                      : ""
                      }`}
                  >
                    <a
                      className="nav-link dropdown-toggle text-white"
                      href="#"
                      id="streamerDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Streamer
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="streamerDropdown"
                    >
                      <li>
                        <Link className="dropdown-item" to="/stream_categories">
                          Stream Categories
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/stream_videos">
                          Stream Videos
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/stream_vidcategories">
                          Video Category
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/stream_users">
                          Stream Users
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
                <li
                  className={`nav-item dropdown ${
                    location.pathname === "/asset_heads" ||
                    location.pathname === "/asset_item_masters" ||
                    location.pathname === "/asset_departments" ||
                    location.pathname === "/asset_list"
                      ? "active"
                      : ""
                  }`}
                >
                  <a
                    className="nav-link dropdown-toggle text-white"
                    href="#"
                    id="assetMgmtDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Asset MNGT
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="assetMgmtDropdown">
                    <li>
                      <Link className="dropdown-item" to="/asset_heads">
                        Asset Head
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/asset_item_masters">
                        Item Master
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/asset_departments">
                        Asset Department
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/asset_list">
                        Asset List
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={`nav-item ${location.pathname === "/resetpass" ? "active" : ""
                    }`}
                >
                  <Link className="nav-link text-white" to="/resetpass">
                    Reset Password
                  </Link>
                </li>
                {user && (user.id == 1 || user.id == 3) && allowEdit && (
                  <li
                    className={`nav-item ${location.pathname === "/company_view" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/company_view">
                      Company
                    </Link>
                  </li>
                )}
                {user && user.department_id !== 1 && allowEdit && (
                  <li
                    className={`nav-item ${location.pathname === "/add_task" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/add_task">
                      Add Task
                    </Link>
                  </li>
                )}
                {user && user.department_id !== 1 && allowEdit && (
                  <li
                    className={`nav-item ${location.pathname === "/bulk_task" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/bulk_task">
                      Bulk Task
                    </Link>
                  </li>
                )}
                {user && user.department_id !== 1 && (
                  <li
                    className={`nav-item ${location.pathname === "/task_view" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/task_view">
                      Your Task
                    </Link>
                  </li>
                )}
                {user && user.department_id !== 1 && (
                  <li
                    className={`nav-item ${location.pathname === "/task_by_you" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/task_by_you">
                      Task Added By You
                    </Link>
                  </li>
                )}
                {user && user.department_id !== 1 && (
                  <li
                    className={`nav-item ${location.pathname === "/departmenttask" ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link text-white" to="/departmenttask">
                      Department Tasks
                    </Link>
                  </li>
                )}
                <li>
                  {user && user.company_id == 1 && user.department_id == 1 && (
                    <li
                      className={`nav-item ${location.pathname === "/jc_time_live" ? "active" : ""
                        }`}
                    >
                      <Link className="nav-link text-white" to="/jc_time_live">
                        Work Tasks
                      </Link>
                    </li>
                  )}
                </li>
                <li>
                  {user && user.department_id == 1 && (
                    <li
                      className={`nav-item ${location.pathname === "/dl_module" ? "active" : ""
                        }`}
                    >
                      <Link className="nav-link text-white" to="/dl_module">
                        DL
                      </Link>
                    </li>
                  )}
                </li>
                {user && user.company_id != 1 ? (
                  <li className="nav-item">
                    <a
                      className="nav-link text-white"
                      target="_blank"
                      href="http://3.6.125.26/jobcart/tickets"
                    >
                      Customer Support
                    </a>
                  </li>
                ) :
                  <li className="nav-item">
                    <a
                      className="nav-link text-white"
                      target="_blank"
                      href="http://3.6.125.26/jobcart/tickets"
                    >
                      CS
                    </a>
                  </li>

                }
                <li className="nav-item">
                  <span
                    role="button"
                    className="nav-link text-danger"
                    onClick={logoutUser}
                  >
                    Logout
                  </span>
                </li>
              </ul>
            </div>

            <span className="text-warning text-end pull-right text-uppercase mx-3">
              {companyname}
            </span>
            <span className="text-white text-end pull-right px-2">Hi👋🏻</span>
            <span className="text-white text-end pull-right text-uppercase">
              {" "}
              {user.name + " " + user.last_name}
            </span>
          </div>
        </nav>

        <div className="container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/add_task" element={<Tasks />} />
            <Route path="/task_view" element={<Tasksview />} />
            <Route path="/task_by_you" element={<Yourtask />} />
            <Route path="/departmenttask" element={<Departmenttask />} />
            <Route path="/week_month_task" element={<Weekmonthview />} />
            <Route path="/week_month_add" element={<Weekmonthadd />} />
            <Route path="/report" element={<Report />} />
            <Route path="/department" element={<Departmentview />} />
            <Route path="/department_add" element={<Department_add />} />
            <Route path="/designation_add" element={<Designation_add />} />
            <Route path="/resetpass" element={<Resetpassword />} />
            <Route path="/designation" element={<Designation />} />
            <Route path="/company_add" element={<Compny_add />} />
            <Route path="/company_view" element={<Company_view />} />
            <Route path="/bulk_task" element={<BulkTask />} />
            <Route path="/bulk_task_group" element={<Bulk_task_group />} />
            <Route path="/bulk_task_week" element={<BulkTaskWeek />} />
            <Route path="/amc_dash" element={<Amc_dashboard />} />
            <Route path="/jc_dash" element={<Jc_dash />} />
            <Route path="/group_tasks" element={<List_group />} />
            <Route path="/group_create" element={<Group_task />} />
            <Route path="/jc_time_live" element={<Jc_timelive />} />
            <Route path="/dl_module" element={<Dlmodule />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/stream_categories" element={<StreamCategoryList />} />
            <Route path="/stream_videos" element={<StreamVideoList />} />
            <Route path="/stream_vidcategories" element={<StreamVidCategoryList />} />
            <Route path="/stream_users" element={<StreamUserList />} />
            <Route path="/asset_heads" element={<AssetHeadList />} />
            <Route path="/asset_item_masters" element={<AssetItemMasterList />} />
            <Route path="/asset_departments" element={<AssetDepartmentList />} />
            <Route path="/asset_list" element={<AssetList />} />
            <Route path="/jobcart/tickets" element={<Jc_amc />} />
          </Routes>
        </div>
      </>
    );
  }
}

export default Auth;
